import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ILabApplication } from '../../../models/application-menu/lab-application';
import { LabUserMenuService } from '../../../services/lab-user-menu/lab-user-menu.service';
import { LabApplicationMenuService } from '../../../services/application-menu/lab-application-menu.service';
import { SettingsService } from '../../../services/core/settings.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { IApplicationTypes } from '../../../models/lab-user-menu/application-types';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { INewApplicationRequest } from '../../../models/lab-user-menu/new-application-request';
import { INewApplicationResult } from '../../../models/lab-user-menu/new-application-result';
import { Router } from '@angular/router';
import { SharedService } from '../../../shared/services/shared.service';
import { ApplicationReportComponent } from '../../reports/applicationReport/applicationReport.component';
import { TechnologyReportComponent } from '../../reports/technologyReport/technologyReport.component';
import { FoaReportComponent } from '../../reports/foaReport/foaReport.component';

@Component({
  selector: 'app-lab-applications',
  templateUrl: './lab-applications.component.html',
  styleUrls: ['./lab-applications.component.scss']
})
export class LabApplicationsComponent implements OnInit {
  @Input() orelapId: string = '';
  @Input() labName: string = '';
  currentOrelapId: string = 'current';
  today: string = new Date().toDateString();

  labApplications: ILabApplication[] = [];
  selectedApplication: ILabApplication =
    {
      accreditationType: '',
      application: '',
      approvedByAdmin: '',
      assessorsAllocated: '',
      labApplicationId: 0,
      lockedByAdmin: '',
      onSiteAssessment: '',
      createDate: '',
      laboratoryName: '',
      modifiedDate: '',
      orelapId: '',
      status: '',
      trackingNumber: '',
      uniqueLabId: '',
      userCreate: '',
      userModified: '',
      labId: 0
    };

  newApplicationResult: INewApplicationResult = {
    applicationCreated: false,
    newMethodFound: false
  }

  displayNewApplicationMessage: boolean = false;

  readonly: boolean = true;
  isPrimary = false;

  displayedColumns: string[] = ['select', 'application', 'onSiteAssessment', 'approvedByAdmin', 'lockedByAdmin', 'createDate', 'status', 'action'];
  dataSource = new MatTableDataSource<ILabApplication>(this.labApplications);

  @ViewChild('ApplicationPaginator') paginator: MatPaginator;
  @ViewChild('ApplicationSort') sort: MatSort;

  constructor(private labUserMenuService: LabUserMenuService,
    private labApplicationMenuService: LabApplicationMenuService,
    public settings: SettingsService,
    public dialog: MatDialog,
    private sharedService: SharedService,
    private router: Router) { }

  ngOnInit(): void {
    if (this.orelapId !== this.currentOrelapId) {
      this.getApplications();
    }
  }

  getApplications(): void {
    this.labUserMenuService.getLabApplications(this.orelapId).subscribe(
      (response) => {
        this.labApplications = response
      },
      error => console.log('error', error),
      () => {
        this.dataSource.data = this.labApplications;
        this.currentOrelapId = this.orelapId;
        this.sharedService.currentOrelapId = this.currentOrelapId;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (this.labApplications.length > 0) {
          let labApplication = this.labApplications[0];
          this.sharedService.currentLabId = labApplication.labId;
          this.sharedService.currentLabName = labApplication.laboratoryName;
          this.sharedService.currentOrelapId = labApplication.orelapId;
          this.isPrimary = labApplication.accreditationType == 'Primary';
          this.labApplicationMenuService.getLab(labApplication.labId).subscribe(
            response => this.sharedService.currentLab = response,
            error => console.log('error', error)
          );
        }
      }
    );
  }

  filterTable(value: string) {
    this.dataSource.filter = value.trim().toLowerCase();
  }

  selectApplication(application: ILabApplication) {
    this.selectedApplication = application;
    this.sharedService.currentApplication = application;

    this.labApplicationMenuService.getLab(application.labId).subscribe(
      response => this.sharedService.currentLab = response,
      error => console.log('error', error)
    );
  }

  selectInspection(application: ILabApplication) {
    this.selectApplication(application);
    this.router.navigate(['/inspection']);
  }

  viewApplication(type: string): void {
    this.sharedService.readonlyApplication = type == 'view';
  }

  deleteApplication(): void {
    if (confirm("Delete " + this.selectedApplication.application + " application?")) {
      this.labApplicationMenuService.deleteApplication(this.selectedApplication.labId, this.selectedApplication.labApplicationId).subscribe(
        () => {
          this.selectedApplication.labId = 0;
          this.getApplications()
        },
        error => console.log('error', error)
      );
    }
  }

  createNewApplication(): void {
    if (this.labApplications.length == 0) {
      this.sharedService.currentLabName = this.labName;
    }
    const dialogRef = this.dialog.open(NewApplicationDialog,
      {
        minWidth: '350px',
        panelClass: this.settings.theme === 'dark' ? 'theme-dark' : ''
      });

    dialogRef.afterClosed().subscribe(
      response => {
        if (response === 'cancel' || response == null) {
          return;
        }
        this.newApplicationResult = response;
        this.displayNewApplicationMessage = true;
        if (this.newApplicationResult.applicationCreated) {
          this.getApplications();
        }
      }
    );
  }



  getApplicationReport() {
    // this.labApplicationMenuService.getApplicationReport(this.sharedService.currentApplication.labId, this.sharedService.currentApplication.labApplicationId).subscribe(
    //   response => this.downloadFile("ApplicationReport-" + this.today, response),
    //   error => console.log('error', error)
    // );
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }


  applicationReport() {

    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = '90vw';
    config.maxWidth = '95vw';
    config.height = '90vh';
    // config.data = response;
    config.panelClass = this.settings.theme === 'dark' ? 'theme-dark' : '';

    const dialogRef = this.dialog.open(ApplicationReportComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        // Dialog closed
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  foaReport() {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = '90vw';
    config.maxWidth = '95vw';
    config.height = '90vh';
    // config.data = response;
    config.panelClass = this.settings.theme === 'dark' ? 'theme-dark' : '';

    const dialogRef = this.dialog.open(FoaReportComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        // Dialog closed
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  techReport() {
    console.log('tech report', this.sharedService.currentApplication);

    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = '90vw';
    config.maxWidth = '95vw';
    config.height = '90vh';
    config.data = this.sharedService.currentApplication;
    config.panelClass = this.settings.theme === 'dark' ? 'theme-dark' : '';

    const dialogRef = this.dialog.open(TechnologyReportComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        // Dialog closed
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

}


/********************************************/

@Component({
  selector: 'new-application-dialog',
  templateUrl: './dialog-new-application.html'
})

export class NewApplicationDialog implements OnInit {
  applicationTypes: IApplicationTypes = {
    newPrimary: 'N',
    newSecondary: 'N',
    primaryRenewal: 'N',
    secondaryRenewal: 'N',
    reAccreditation: 'N',
    changeAddress: 'N',
    additionalParameters: 'N',
    changeOwnership: 'N',
    changePersonnel: 'N',
    changeName: 'N',
    withdraw: 'N',
    complaints: 'N',
    misc: 'N',
    newApplication: ''
  };

  disableRenewalButton = false;

  newApplicationForm = new UntypedFormGroup({
    type: new UntypedFormControl('', Validators.required)
  });

  newApplicationResult: INewApplicationResult = {
    applicationCreated: false,
    newMethodFound: false
  }

  constructor(public dialogRef: MatDialogRef<NewApplicationDialog>,
    private labApplicationMenuService: LabApplicationMenuService,
    private sharedService: SharedService) { }

  ngOnInit(): void {
    console.log('popup ' + this.sharedService.currentOrelapId);
    this.labApplicationMenuService.getApplicationTypes(this.sharedService.currentOrelapId).subscribe(
      response => this.applicationTypes = response,
      error => console.log('error', error),
      () => {
        if (this.applicationTypes.newApplication === 'N') {
          this.newApplicationForm.get('type').disable();
        }
      }
    );
    this.disableRenewalButton = false;
  }

  submitRequest(): void {
    if (this.newApplicationForm.valid && this.applicationTypes.newApplication !== 'N') {
      var request: INewApplicationRequest = {
        orelapId: this.sharedService.currentOrelapId,
        applicationType: this.newApplicationForm.get('type').value,
        labName: this.sharedService.currentLabName
      }
      this.disableRenewalButton = true;
      this.labApplicationMenuService.createApplication(request).subscribe(
        response => {
          this.newApplicationResult = response;
          this.disableRenewalButton = false;
        },
        error => console.log('error', error),
        () => this.dialogRef.close(this.newApplicationResult)
      );
    }
  }

  cancel(): void {
    this.dialogRef.close('cancel');
  }

}
